import PROFIL_ECRITURE from '../../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../../constants/mouvements/typePiece';
import BaseProfilEcritureOPO from '../BaseProfilEcritureOPO';

class ProfilEcritureOPOAvanceSurMarcheFonc extends BaseProfilEcritureOPO {
	constructor() {
		super();
		this.code = PROFIL_ECRITURE.DEPENSE.OPO_AVANCE_MARCHE_FONC;
		this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDRE_PAIE;
		this.naturePiece = NATURE_PIECE.DEPENSE.AVANCE_FORFAIT;
		this.typePiece = TYPE_PIECE.DEPENSE.ORDRE_PAIEMENT;
		this.modeDeReglement = [
			MODE_REGLEMENT.DEPENSE.NUMERAIRE,
			MODE_REGLEMENT.DEPENSE.CHEQUE,
			MODE_REGLEMENT.DEPENSE.VIREMENT,
			MODE_REGLEMENT.DEPENSE.VIREMENT_GROS_MT,
			MODE_REGLEMENT.DEPENSE.VIREMENT_ETRANGER,
			MODE_REGLEMENT.DEPENSE.OPERATION_ORDRE,
		];
		this.panels = [...this.panels];
	}
}

export default ProfilEcritureOPOAvanceSurMarcheFonc;
